import React from 'react'

import { SxProps } from '@mui/material'

import DefaultListItemButton from 'components_new/atoms/List/ListItemButton'
import Icon, { IconName } from 'components_new/atoms/Icon'
import ListItemText from 'components_new/atoms/List/ListItemText'

interface ListItemProps {
  body?: string
  dense?: boolean
  disablePadding?: boolean
  gutterBottom?: boolean
  icon?: {
    name: IconName
  }
  onClick?: () => void
  title?: string
  size?: 'small' | 'medium'
  sx?: SxProps
}

const ListItemButton = React.forwardRef((props: ListItemProps, ref: any) => {
  const { body, dense, gutterBottom, icon, onClick, title, size, sx } = props

  return (
    <DefaultListItemButton
      dense={dense}
      onClick={onClick}
      ref={ref}
      sx={{
        borderRadius: 1,
        height: size === 'small' ? 38 : 54,
        mb: gutterBottom ? 1 : undefined,
        px: 1,
        py: 0.5,
        ['&:hover .MuiSvgIcon-root, &:hover .MuiTypography-root']: {
          color: 'text.primary'
        },
        ...sx
      }}
    >
      {icon ? (
        <Icon name={icon.name} sx={{ color: 'action.active', mr: 0.75 }} />
      ) : null}
      <ListItemText
        primary={title}
        primaryTypographyProps={{
          lineHeight: 0,
          variant: 'button',
          sx: { color: 'action.active' }
        }}
        secondary={body}
      />
    </DefaultListItemButton>
  )
})

export default ListItemButton
